import * as React from "react";
import { Input, Table, Header, Divider, Segment, Message } from "semantic-ui-react";
import 'katex/dist/katex.min.css';
import UFileUpload from "../../../../components/util/UFileUpload";


const { jStat } = require('jstat');
const { InlineMath, BlockMath } = require('react-katex')


interface INbdProps {
}

interface INbdState {
}


class CV2Face extends React.Component<INbdProps, INbdState> {

  constructor(props: INbdProps) {
    super(props);
    this.state = {
    };


  }


  render() {
    return (
      <div>
        <Header as='h3'>OpenCVによる顔認識</Header>

        <Divider />

        <UFileUpload />

      </div>
    );
  };

}
export default CV2Face;
